module.exports = __webpack_public_path__ + "img/imgRemove05.a940e6c6.png";